<template>
  <main class="main page-inside">
    <div class="profile">
      <div class="section profile-section">
        <div class="wrapper">
          <div class="title title-main">PROFILE</div>
          <div class="profile-content">
            <div class="profile-info">
              <img src="../img/corners3/top-left-corner.svg" class="top-left" />
              <img
                src="../img/corners3/top-right-corner.svg"
                class="top-right"
              />
              <img
                src="../img/corners3/bottom-left-corner.svg"
                class="bottom-left"
              />
              <img
                src="../img/corners3/bottom-right-corner.svg"
                class="bottom-right"
              />
              <div class="profile-info-wrapper">
                <div class="avatar">
                  <img :src="$parent.profileData.avatar" class="img" />
                </div>
                <div class="text">
                  <div class="row">
                    <div class="desc">Username:</div>
                    <div class="desc dark">
                      {{ $parent.profileData.name }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="desc">ID:</div>
                    <div class="desc dark">
                      {{ $parent.profileData.steam_id }}
                    </div>
                  </div>
                </div>
                <div class="balance-block">
                  <div class="balance-block-wrapper">
                    <img src="../img/walletDark.svg" class="img" />
                    <div class="desc big dark amount">
                      <b>{{ $parent.profileData.balance }} </b>

                      <img src="../img/coin.svg" class="coin" />
                    </div>
                    <div class="button" @click="$parent.openTopUpModal">
                      TOP UP
                    </div>
                  </div>
                </div>
                <ProfilePayoutBalanceBlock
                  v-if="$parent.settings.payout_enabled"
                  :payout-balance="$parent.profileData.payout_balance"
                  @withdraw="$parent.openWithdrawModal"
                />
                <button class="button" @click="$parent.logout">
                  <span>LOG OUT</span>
                </button>
              </div>
            </div>
            <div class="tables">
              <div class="history-info">
                <div class="nav">
                  <div
                    :class="['button', { active: activeTab == 1 }]"
                    @click="activeTab = 1"
                  >
                    TRANSACTION HISTORY
                  </div>
                  <div
                    :class="['button', { active: activeTab == 0 }]"
                    @click="activeTab = 0"
                  >
                    ORDER HISTORY
                  </div>
                  <div
                    :class="['button', { active: activeTab == 2 }]"
                    @click="activeTab = 2"
                  >
                    SELL REQUESTS
                  </div>
                </div>
                <div
                  class="table-container"
                  v-if="activeTab == 0 && $parent.orderHistory.length"
                >
                  <table>
                    <thead>
                      <tr>
                        <td>Date</td>
                        <td>Items</td>
                        <td>Total price</td>
                        <td>Status</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in $parent.orderHistory" :key="i">
                        <td>{{ $parent.formatDate(item.date) }}</td>
                        <td>
                          <div
                            class="history-product"
                            v-for="(product, i) in item.items"
                            :key="i"
                          >
                            <img :src="imgDomain + product.image" class="img" />
                            <div class="name">
                              {{ product.display_name }}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="flex">
                            <b class="price">{{ item.total_price }}</b>
                            <img src="../img/coin.svg" class="coin" />
                          </div>
                        </td>
                        <td :class="'status ' + item.status">
                          <span>{{ item.status }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="table-container"
                  v-if="
                    activeTab == 1 &&
                    $parent.depositHistory &&
                    $parent.depositHistory.length
                  "
                >
                  <table>
                    <thead>
                      <tr>
                        <td>Date</td>
                        <td>Type</td>
                        <td>Total</td>
                        <td>Amount</td>
                        <td>Status</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in $parent.depositHistory" :key="i">
                        <td>{{ $parent.formatDate(item.date) }}</td>
                        <td>Top Up Balance</td>
                        <td>
                          {{ item.amount }}
                          {{ $parent.currency }}
                        </td>
                        <td>
                          <div class="flex">
                            <b class="price">{{ item.amount }}</b>
                            <img src="../img/coin.svg" class="coin" />
                          </div>
                        </td>
                        <td :class="'status ' + item.status">
                          <span>{{ item.status }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <ProfileSellRequestsTab
                  v-if="activeTab == 2"
                  :sell-request-history="$parent.sellRequestHistory"
                  :sell-request-meta="$parent.sellRequestMeta"
                  :format-date="$parent.formatDate"
                  :settings="$parent.settings"
                  @coming-soon="$parent.openComingSoonModal"
                  @sell-items="$parent.openSellItemsModal"
                  @view-offer="$parent.openCounterOfferModal"
                  @change-page="$parent.getSellRequestHistory"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import ProfilePayoutBalanceBlock from '../components/profile/ProfilePayoutBalanceBlock.vue'
import ProfileSellRequestsTab from '../components/profile/ProfileSellRequestsTab.vue'

export default {
  name: 'Profile',
  props: [],
  components: {
    ProfilePayoutBalanceBlock,
    ProfileSellRequestsTab,
  },
  data: function () {
    return {
      activeTab: 0,
      imgDomain: '',
    }
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN
  },
  methods: {},
}
</script>
